export default "__VITE_ASSET__bxVRGs7S__"